import React from 'react';
import CreateLab from "../../components/labs/CreateLab"

 const CreateLabPage = () => {
     return(
          <>
          <CreateLab />
          </>
     )
 }

 export default CreateLabPage